import { transient, autoinject } from "aurelia-framework";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { NotificationClientService, NotificationType } from "@rightship-tech/common-ui/services/basic/notification-client.service";
import { SaveDocumentVesselSubscriptionRequest } from "../../../models/document-management.models";
import { DocumentRequirementApi } from "../../../apis/document-requirement.api";

@autoinject
@transient()
export class DialogDeleteWatchlistVesselsConfirmation {
    
    private _documentRequirementId: number;
    public documentRequirementName: string;
    public selectedVesselCount: number;
    public totalVesselCount: number;
    public onDelete: (() => void);

    constructor(private dialogClient: DialogClientService, private documentManagementApi: DocumentRequirementApi,
        private notificationClientService: NotificationClientService) { }

    activate(model: { documentRequirementId: number, documentRequirementName: string, selectedVesselCount: number, totalVesselCount: number, onDelete: (() => void)}) {
        this._documentRequirementId = model.documentRequirementId;
        this.documentRequirementName = model.documentRequirementName;
        this.selectedVesselCount = model.selectedVesselCount;
        this.totalVesselCount = model.totalVesselCount;
        this.onDelete = model.onDelete;
    }

    //Cancel
    cancel() {
        this.dialogClient.hide();
    }

    //Remove
    async remove() {
        try {
            const request: SaveDocumentVesselSubscriptionRequest = {
                documentRequirementId: this._documentRequirementId,
                vesselSubscriptions: []
            };
            await this.documentManagementApi.saveDocumentVesselSubscription(request);
            if(this.onDelete) this.onDelete();
            this.dialogClient.hide();
            this.notificationClientService.show("Vessels removed from Watchlist successfully", "", NotificationType.Success);
        }
        catch (error) {
            console.error(error);
            this.notificationClientService.show("An error occurd while trying to save the watchlist", "", NotificationType.Error);
        }
    }
}